const TOPICS = [
  { label: '进击的巨人 完结篇', heat: '98.6万讨论', tag: '热血' },
  { label: '鬼灭之刃 无限城篇', heat: '87.3万讨论', tag: '战斗' },
  { label: '咒术回战 第二季', heat: '76.8万讨论', tag: '奇幻' },
  { label: '间谍过家家 剧场版', heat: '65.2万讨论', tag: '搞笑' },
  { label: '葬送的芙莉莲', heat: '58.4万讨论', tag: '治愈' },
  { label: '我推的孩子 第二季', heat: '52.1万讨论', tag: '偶像' },
  { label: '防风少年', heat: '43.7万讨论', tag: '校园' },
  { label: '怪兽8号', heat: '39.5万讨论', tag: '科幻' },
  { label: '败犬女主太多了', heat: '35.8万讨论', tag: '恋爱' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">动漫圈最热讨论，紧跟追番潮流</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((item) => (
            <a
              key={item.label}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-3 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full cursor-pointer hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-200"
            >
              <span className="px-2 py-0.5 text-[11px] font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                {item.tag}
              </span>
              <span className="text-sm text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}